import { generateUUID } from "../other/Utils";
import {
  FETCH_USERS_CHATS_START,
  FETCH_USERS_CHATS_SUCCESS,
  FETCH_USERS_CHATS_FAILURE,
  FETCH_USERS_MESSAGES_START,
  FETCH_USERS_MESSAGES_SUCCESS,
  FETCH_USERS_MESSAGES_FAILURE,
  SEND_MESSAGE_START,
  SEND_MESSAGE_SUCCUSS,
  SEND_MESSAGE_FAILED
} from "../store/types";

export const CreateChat = (ChatData) => (dispatch) => (firebase) => {
  const { SingleEnquiryChatRefs, auth } = firebase;
  const d = new Date();
  let CreateData = {
    enquiryInfo: {
      area: ChatData.address.suburb,
      id: ChatData.id
    },
    chatName: `${ChatData.OwnerName} ${ChatData.CompanyName ? `from ${ChatData.CompanyName}` : ''} `,
    id: ChatData.id,
    Members: ChatData.Brokers,
    Messages: [
      {
        _id: 1,
        createdAt: d.getTime(),
        text: `Hello There everyone \nThis is an auto generated Message to Show the enquiry details\nThis Enquiry is for ${ChatData.OwnerName} ${ChatData.CompanyName ? `from ${ChatData.CompanyName}\nThey want a [Fill in with data API requests]` : ''}  
        `,
        user: {
          _id: 0,
          firstName: "Auto",
          lastName: "Generated"
        }
      },
    ],
  };

  SingleEnquiryChatRefs(ChatData.id).set(CreateData);
};

export const FetchChats = () => (dispatch) => (firebase) => {
  const { EnquiryChatRefs, auth } = firebase;

  dispatch({
    type: FETCH_USERS_CHATS_START,
    payload: null,
  });

  EnquiryChatRefs.on("value", snapshot => {
    if (snapshot.val()) {
      const Chats = Object.values(snapshot.val());
      let myChatsArr = []
      for (let index = 0; index < Chats.length; index++) {
        const element = Chats[index];

        if (element.Members) {
          for (let j = 0; j < element.Members.length; j++) {

            const Members = element.Members[j];

            if (Members.id === auth.currentUser.uid) {
              myChatsArr.push({
                chatName: element.chatName,
                Members: element.Members,
                id: element.id,
                enquiryInfo: element.enquiryInfo,
                latestMessage: Object.values(element.Messages)[Object.values(element.Messages).length - 1]
              });
            }
          }
        }


      }

      if (myChatsArr.length > 0) {
        dispatch({
          type: FETCH_USERS_CHATS_SUCCESS,
          payload: myChatsArr,
        });
      }

    }

  },
    (errorObject) => {
      console.log("The read failed: " + errorObject.name);
    }
  );

};
export const fetchChatMessages = (id) => (dispatch) => (firebase) => {
  const { ChatMessageRefs, auth } = firebase;

  dispatch({
    type: FETCH_USERS_MESSAGES_START,
    payload: null,
  });

  ChatMessageRefs(id).on("value", snapshot => {

    if (snapshot.val()) {
      const Messages = Object.values(snapshot.val());


      dispatch({
        type: FETCH_USERS_MESSAGES_SUCCESS,
        payload: Messages.sort((a, b) => b.createdAt - a.createdAt),
      });
    } else {
      dispatch({
        type: FETCH_USERS_MESSAGES_SUCCESS,
        payload: null,
      });
    }

  },
    (errorObject) => {
      console.log("The read failed: " + errorObject.name);
    }
  );

};

/**
 * 
 * Send a message to a group chat
 * 
 * @param {chat}  chat holds the infomation that needs to be sent to a message and save it into the database
 * @param {enquiryData} enquiryData the Data of the enquiry
 * 
 *  
 */

export const SendChatMesssage = (chat, enquiryData) => (dispatch) => async (firebase) => {
  const { ChatMessageRefs, ChatMediaStorageRef, auth, api } = firebase;


  try {
    dispatch({
      type: SEND_MESSAGE_START,
      payload: null,
    });
    if (chat.messagePayload.hasMedia) {
      const blob = await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
          resolve(xhr.response);
        };
        xhr.onerror = function (e) {
          reject(new TypeError("Network request failed"));
        };
        xhr.responseType = "blob";
        xhr.open("GET", chat.messagePayload.uri, true);
        xhr.send(null);
      });
      let mediaId = generateUUID(32);
      if (mediaId) {
        ChatMediaStorageRef(chat.id, mediaId)
          .put(blob)
          .then(() => {
            ChatMediaStorageRef(chat.id, mediaId).getDownloadURL()
              .then((downloadURL) => {
                let MessagePayload = { ...chat.messagePayload, uri: downloadURL }

                ChatMessageRefs(chat.id)
                  .push(MessagePayload)
                  .then(() => {

                    dispatch(
                      api.SendEnquiryGroupChatNotification({
                        office: enquiryData.office,
                        title: "New Message",
                        msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has sent Media on an Enquiry`,
                        content: {
                          type: "chat",
                          content: {chatid:chat.id,enquiryData},
                        },
                      },
                        Object.values(enquiryData.archivedbroker ?? {}))
                    );

                    dispatch({
                      type: SEND_MESSAGE_SUCCUSS,
                      payload: null,
                    });
                  });
              })
          })
      }
    }
    else {
      ChatMessageRefs(chat.id)
        .push(chat.messagePayload)
        .then(() => {
          console.log('sending message')
          dispatch(api.SendEnquiryGroupChatNotification({
            office: enquiryData.office,
            title: "New Message",
            msg: `${auth.currentUser.profile.firstName} ${auth.currentUser.profile.lastName} has sent a message on an Enquiry`,
            content: {
              type: "chat",
              content: {chatid:chat.id,enquiryData: enquiryData},
            },
          },
          Object.values(enquiryData.archivedbroker ?? {}))
          );


          dispatch({
            type: SEND_MESSAGE_SUCCUSS,
            payload: null,
          });
        });
    }

  } catch (error) {
    console.log('error', error)
  }




};

export const leaveChat = (chat) => (dispatch) => (firebase) => {
  const { ChatMembersRefs, auth } = firebase;




  ChatMembersRefs(chat.id)
    .once("value", (res) => {
      const Members = Object.values(res.val());

      if (Members.length > 0) {
        console.log('Members', Members)
        const objWithIdIndex = Members.findIndex((obj) => obj.id === auth.currentUser.uid);

        if (objWithIdIndex > -1) {
          Members.splice(objWithIdIndex, 1);
        }

        console.log('Members', Members)

        ChatMembersRefs(chat.id).set(Members);

      }


    });


};
